(function () {
  'use strict';

  var DESKTOP_BP = 768;
  function isDesktop() { return window.innerWidth >= DESKTOP_BP; }

  function initNav3() {
    document.querySelectorAll('.nav3-wrapper--mobile').forEach(function (wrapper) {
      if (wrapper.dataset.nav3Bound) return;
      wrapper.dataset.nav3Bound = '1';

      var textItems = wrapper.querySelectorAll('.nav3-text-item--has-tiles');
      var stage = wrapper.querySelector('.nav3-tile-stage');
      if (!textItems.length) return;

      var context = wrapper.getAttribute('data-nav3-context');

      // ----- DESKTOP -----
      if (context === 'desktop') {
        // Auto-activate first item
        activateItem(textItems[0], textItems, stage);

        textItems.forEach(function (item) {
          var link = item.querySelector('.nav3-text-link--has-tiles');
          if (!link) return;

          // Click on desktop
          link.addEventListener('click', function (e) {
            e.preventDefault();
            activateItem(item, textItems, stage);
          });

          // Hover on desktop
          item.addEventListener('mouseenter', function () {
            activateItem(item, textItems, stage);
          });
        });

      } else {
        // ----- MOBILE -----
        textItems.forEach(function (item) {
          var link = item.querySelector('.nav3-text-link--has-tiles');
          if (!link) return;

          link.addEventListener('click', function (e) {
            e.preventDefault();

            var targetId = item.getAttribute('data-nav3-target');
            var panel = wrapper.querySelector('[id^="' + targetId + '"]');
            if (!panel) return;

            var isOpen = item.classList.contains('nav3-text-item--active');

            if (isOpen) {
              // Close this item if already open
              item.classList.remove('nav3-text-item--active');
              panel.style.display = 'none';
              return;
            }

            // Close all other items first (exclusive accordion)
            textItems.forEach(function (i) {
              i.classList.remove('nav3-text-item--active');
              var p = i.querySelector('.nav3-tile-panel');
              if (p) p.style.display = 'none';
            });

            // Open clicked item
            item.classList.add('nav3-text-item--active');
            if (!item.contains(panel)) {
              item.appendChild(panel); // move panel inline
            }
            panel.style.display = 'block';
          });
        });
      }
    });
  }

  function activateItem(item, textItems, stage) {
    textItems.forEach(function (i) { i.classList.remove('nav3-text-item--active'); });
    stage.querySelectorAll('.nav3-tile-panel').forEach(function (p) { p.classList.remove('nav3-tile-panel--active'); });

    item.classList.add('nav3-text-item--active');
    var targetId = item.getAttribute('data-nav3-target');
    var panel = stage.querySelector('[id^="' + targetId + '"]');
    if (panel) panel.classList.add('nav3-tile-panel--active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav3);
  } else {
    initNav3();
  }

  // Re-init when mobile drawer opens
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (
          node.classList.contains('mobile-navigation-drawer') ||
          (node.querySelector && node.querySelector('.nav3-wrapper--mobile'))
        )) {
          setTimeout(initNav3, 150);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();